<template>
  <v-app>
    <v-main>
      <v-container>
        <consultar-cupons />
      </v-container>
    </v-main>
    <menu-rodape />
  </v-app>
</template>


<script>
import ConsultarCupons from "./components/ConsultarCupons.vue";
import MenuRodape from "./components/MenuRodape.vue";
export default {
  components: { MenuRodape, ConsultarCupons },
};
</script>

<style>
</style>

<style>
.v-main,
.container {
  overflow: hidden !important;
  height: 90vh !important;  
  background: rgb(248, 201, 52);
  background: linear-gradient(
    360deg,
    rgb(226, 183, 42) 0%,
    rgb(226, 183, 42) 35%,
    rgb(236, 201, 43) 59%,
    rgba(251, 234, 59, 1) 82%
  );
}

.container {
  /* Location of the image */
  background-image: url("assets/fundo-55-anos.jpg");

  /* Image is centered vertically and horizontally at all times */
  background-position: center center;

  /* Image doesn't repeat */
  background-repeat: no-repeat;

  /* Makes the image fixed in the viewport so that it doesn't move when 
     the content height is greater than the image height */
  /*background-attachment: fixed;*/

  /* This is what makes the background image rescale based on its container's size */
  background-size: contain;

  /* Pick a solid background color that will be displayed while the background image is loading */
  /*background-color: #464646;

  /* SHORTHAND CSS NOTATION
   * background: url(background-photo.jpg) center center cover no-repeat fixed;
   */
}

/* For mobile devices */
@media only screen and (max-width: 767px) {
  .container {
    /* The file size of this background image is 93% smaller
     * to improve page load speed on mobile internet connections */
    /*background-image: url("assets/fundo-55-anos-vertical.jpg");*/
    background-image: url("assets/fundo-mobile.png") !important;
    background-size: contain; /* A imagem cobrirá todo o elemento */
    background-position: top; /* Posição central da imagem */    
    background-attachment: fixed;
  }

  .v-main {
    background: rgb(197, 106, 0);
    background: linear-gradient(
      90deg,
      rgba(197, 106, 0, 1) 0%,
      rgba(230, 148, 0, 1) 40%,
      rgba(230, 148, 0, 1) 60%,
      rgba(187, 92, 0, 1) 100%
    );
  }
}
</style>
